import {
  makeMapStateToProps,
  mapDispatchToProps,
  StateProps,
  DispatchProps,
  ContainerProps,
} from "./map-to-props-factory";
import { createUniversalConnector } from "../universal-connector-factory";
import { withSportsbookBetslipContext, type SportsbookBetslipContext } from "../../context/sportsbook";
import { ComponentProps } from "./props";

export default withSportsbookBetslipContext(
  ({ localization, config, capabilities, preferences }: SportsbookBetslipContext) => ({
    localization,
    config,
    capabilities,
    preferences,
  }),
)(
  createUniversalConnector<StateProps, DispatchProps, ContainerProps, ComponentProps>(
    makeMapStateToProps,
    mapDispatchToProps,
  ),
);
